import anime from 'animejs'


export class Effect {
  audio?: HTMLAudioElement
  playID?: anime.AnimeInstance
  stopID?: anime.AnimeInstance
  src: string
  loop?: Boolean
  actx?: AudioContext
  ctxAudio?: AudioBufferSourceNode
  audioBuffer?: AudioBuffer
  gainNode?: GainNode
  playRequest: boolean  = false
  playing: boolean = false
  
  constructor(src: string, onLoad?: Function, loop?: Boolean, playInstant?: boolean) {
    this.loop = loop
    this.src = src
    //@ts-ignore
    if(loop) {
    //@ts-ignore
      const ac = (window.webkitAudioContext || AudioContext)
      //@ts-ignore
      this.actx = new ac()

      function unlockAudioContext(context: any) {
        if (context.state !== 'suspended') return;
        const b = document.body;
        const events = ['touchstart','touchend', 'mousedown','keydown'];
        events.forEach(e => b.addEventListener(e, unlock, false));
        function unlock() { context.resume().then(clean); }
        function clean() { events.forEach(e => b.removeEventListener(e, unlock)); }
      }

      unlockAudioContext(this.actx);

      //@ts-ignore      
      if(window.webkitAudioContext ) {
        fetch(src, {mode: 'cors'})
          .then(res => res.arrayBuffer())
          .then(arrB => this.actx!.decodeAudioData(arrB, audioB => this.audioBuffer = audioB))
          .then(() => playInstant && this.play())
          .then(() => {
            if(this.playRequest) {
              this.stop(true)
              this.play()
            }
          })
          
        } else {
          fetch(src, {mode: 'cors'})
          .then(res => res.arrayBuffer())
          .then(arrB => this.actx!.decodeAudioData(arrB))
          .then(audioB => this.audioBuffer = audioB)
          .then(() => playInstant && this.play())
          .then(() => {
            if(this.playRequest) {
              this.stop(true)
              this.play()
            }
          })
      }
      

    } else {
      this.audio = new Audio(src)
      this.audio!.loop = Boolean(loop)
      //@ts-ignore
      this.audio!.preload = true
      //@ts-ignore
      this.audio.addEventListener('loadeddata', onLoad   ? onLoad : () => {} )
      this.audio!.volume = 0
    }
  }

  play(hard?: Boolean, percentageStart: number = 0) {
    this.playRequest = true
    this.playing = true

    
    if(this.audioBuffer && !this.ctxAudio) {
      this.ctxAudio = this.actx!.createBufferSource()
      this.ctxAudio.buffer = this.audioBuffer!
      this.ctxAudio.connect(this.actx!.destination)
      this.ctxAudio.loop = true
      this.gainNode = this.actx!.createGain()
      this.gainNode.connect(this.actx!.destination)
      this.ctxAudio.connect(this.gainNode)
      this.ctxAudio.start(0)
      this.gainNode.gain.setValueAtTime(-1, this.actx!.currentTime)

    // console.log('start')
      
      let volume = {
        value: -1
      }
      
      this.playID = anime({
        targets: volume,
        value: -.5,
        easing: 'linear',
        duration: 450,
        update: () => {
          this.playRequest = false
          this.gainNode!.gain.setValueAtTime(volume.value, this.actx!.currentTime)
        },
        complete: () => {
          this.playID = undefined
        }
      });


    } else if(this.audio && this.audio!.paused) {

      this.audio!.play()
        .catch((e: any ) => console.dir(e))

      this.audio!.currentTime = percentageStart * (this.audio!.duration || 0)
        
      
      let volume = {
        value: 0
      }

      if(this.stopID) this.stopID.pause()
      if(hard) {
        this.audio!.volume = .5
      } else {
        this.playID = anime({
          targets: volume,
          value: 100,
          // round: 1,
          easing: 'linear',
          update: () => {
            this.audio!.volume = volume.value / 100 / 2
          },
          complete: () => {
            this.playID = undefined
          }
        });
      }
    }
  }

  mute() {
    console.log('mute')
    if( this.gainNode) {
      this.gainNode!.gain.setValueAtTime(-1, this.actx!.currentTime)
    }
  }
  
  unmute() {
    console.log('unmute')
    if( this.gainNode) {
      this.gainNode!.gain.setValueAtTime(-.5, this.actx!.currentTime)
    }
  }
  
  pause() {
    if(this.audio) {
      this.audio!.pause()
    }
  }

  setLoop(loop: Boolean) {
  }
  
  stop(hard?: Boolean) {
    
    if(this.ctxAudio && !this.playID) {
      
      let volume = {
        value: -.5
      }
      
      this.stopID = anime({
        targets: volume,
        value: -1,
        easing: 'linear',
        duration: 450,
        update: () => {
          if(this.gainNode) this.gainNode!.gain.setValueAtTime(volume.value, this.actx!.currentTime)
        },
        complete: () => {
          if(this.ctxAudio) this.ctxAudio!.stop()
          this.gainNode = undefined
          this.ctxAudio = undefined
          this.stopID = undefined
        }
      });      
    }
    if(this.audio) {
      let volume = {
        value: 100
      }
      if(this.playID) this.playID.pause()

      if(hard) {
        this.audio!.volume = 0
        this.audio!.currentTime = 0
        this.audio!.pause()

      } else {   
        this.stopID = anime({
          targets: volume,
          value: 0,
          // round: 1,
          easing: 'linear',
          update: () => {
            this.audio!.volume = volume.value / 100 / 2
          },
          complete: () => {
            this.audio!.currentTime = 0
            this.audio!.pause()
            this.stopID = undefined
          }
        });
      }
    }
  }
}